<template>
  <div class="wrap-notfonund f-tac">
    <figure class="figure-img">
      <img src="@/assets/images/icon-404.png" width="100%" height="100%">
    </figure>
    <p class="mg-top10 f-fs16">程序猿们正在玩命开发中，敬请期待哟~~</p>
    <!-- <button class="bullshit-return-home blue-bor" @click="goBack()">返回</button> -->
  </div>
</template>

<script>
export default {
  name: 'Page404',
  computed: {
    message() {
      return this.$route.params.message
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-notfonund{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 200px);
  justify-content: center;
  & .figure-img{
    width: 255px;
    margin: 30px auto;
  }
  & .bullshit-return-home{
    font-size: 16px;
    width: 100px;
    height: 35px;
    color: #fff;
    background: linear-gradient(90deg, #5AA6F9, #4F6DFA);
    border-radius: 6px;
    margin-top: 20px;
  }
}
</style>
